<script>
    import { onMount } from "svelte";
    import LayoutGrid, {Cell as GridCell} from '@smui/layout-grid';
    import DataTable, { Head, Body, Row, Cell } from '@smui/data-table';

    export let settings;
    export let result;
    export let mini = false;
    export let responsiveRow = false;

    let canvas;
    let context;

    const drawImage = (cb) => {
        const image = new Image();
        image.onload = () => {
            context.drawImage(
                image,
                0,
                0
            );
            context.save()
            if(cb) cb()
        };
        image.src = result.dataUrl;
    };

    onMount(() => {
        context = canvas.getContext('2d');
        drawImage();
    });

    const percentToPixel = (percent, totalInPixel) => {
        return Math.round(percent * totalInPixel);
    }

    const addFrame = (annotation) => {

        const rectWidth = percentToPixel(annotation.width, settings.outputDimension[0]);
        const rectHeight = percentToPixel(annotation.height, settings.outputDimension[1]);

        context.strokeStyle = '#9215ff';
        context.beginPath();
        context.rect(
            percentToPixel(annotation.left, settings.outputDimension[0]) - rectWidth/2,
            percentToPixel(annotation.top, settings.outputDimension[1]) - rectHeight/2,
            rectWidth,
            rectHeight
        );
        context.stroke();
        context.restore()
    };

    const overAnnotation = (annotation) => {
        drawImage(() => addFrame(annotation));
    };
    const outAnnotation = () => {
        drawImage();
    };

</script>

{#if !mini}
<div class="{responsiveRow ? 'ge-responsive-row' : 'ge-row'} ge-margin">
    <div class="ge-img-col">
        <h3>{result.fileName}.jpg</h3>
        <canvas style="max-width: 100%;" bind:this={canvas} width={settings.outputDimension[0] + 'px'} height={settings.outputDimension[1] + 'px'} id="resCanvas"></canvas>
    </div>
    <div class="ge-data-col">
        <div class="get-data-column">
            <h3>{result.fileName}.txt</h3>
            <DataTable class="ge-scrollable ge-rect" stickyHeader table$aria-label="User list" style="width: 100%;">
                <Head>
                    <Row>
                        <Cell >Label</Cell>
                        <Cell >x</Cell>
                        <Cell >y</Cell>
                        <Cell >Width</Cell>
                        <Cell >Height</Cell>
                    </Row>
                </Head>
                <Body>
                    {#each result.annotation as annotation}
                        <Row on:mouseover={() => overAnnotation(annotation)} on:mouseout={() => outAnnotation(annotation)}>
                            <Cell numeric>{annotation.label}</Cell>
                            <Cell>{percentToPixel(annotation.left, parseInt(settings.outputDimension[0]))} px</Cell>
                            <Cell>{percentToPixel(annotation.top, parseInt(settings.outputDimension[1]))} px</Cell>
                            <Cell>{percentToPixel(annotation.width, parseInt(settings.outputDimension[0]))} px</Cell>
                            <Cell>{percentToPixel(annotation.height, parseInt(settings.outputDimension[1]))} px</Cell>
                        </Row>
                    {/each}
                </Body>
            </DataTable>
        </div>
    </div>
</div>
{:else}
    <canvas style="max-width: 150px;" bind:this={canvas} width={settings.outputDimension[0] + 'px'} height={settings.outputDimension[1] + 'px'} id="resCanvas"></canvas>
{/if}